module.exports = __webpack_public_path__ + "img/sketch-circle.ff282e41.svg";